import { render, staticRenderFns } from "./CabinetConfigurationMakeChangesLock.vue?vue&type=template&id=0cfa8056&"
import script from "./CabinetConfigurationMakeChangesLock.vue?vue&type=script&lang=ts&"
export * from "./CabinetConfigurationMakeChangesLock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports